import { Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { DataListType } from 'Types/common.types';
import "./details-container.scss"

type DetailsContainerProps = {
    listOfData:DataListType[];
}

const DetailsContainer:React.FC<DetailsContainerProps> = ({
    listOfData,
}) => {

    const [datasource, setDatasource] = useState<DataListType[]>([])

    useEffect(() => {
      if(listOfData.length >= 1){
        setDatasource(listOfData);
      }
    }, [listOfData])
    
    return (
        <>
            <Row gutter={[15, 15]} className="p-30 mb-40 details-container">
                {
                    datasource.map((data,index) => {

                        if(data?.link){
                            return (
                                <Col xs={24} sm={24} md={12} xl={6} key={index}>
                                    <div className="bold-label">{(data.label).toLocaleUpperCase()}</div>
                                    <a href={data.link}>{data.value || '-'}</a>
                                </Col>
                            )
                        }

                        return (
                            <Col xs={24} sm={24} md={12} xl={6} key={index}>
                                <div className="bold-label">{(data.label).toLocaleUpperCase()}</div>
                                <div style={{color: data.color ?? 'black'}}>{data.value || '-'}</div>
                            </Col>
                        )
                    })
                }
            </Row>
        </>
    )
}

export default DetailsContainer